export default "__VITE_ASSET__b5btV3BE__"